import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Box, Link as LinkMaterialUi, makeStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import React from 'react';
import NumberFormat from 'react-number-format';

import { FontSizes } from '../../../../core/config/mainTheme';
import { FinancialStatementResource } from '../../../../generated/model/financialStatementResource';

const LinkOrNumberOrTextOrBooleanCellRenderer: React.FC<ICellRendererParams> = (props) => {
  const classes = useStyles();
  const label = 'Details';

  return (
    <>
      {props.value != null && typeof props.value === 'object' ? (
        props.value.map((resource: FinancialStatementResource, index: number) => {
          return (
            <LinkMaterialUi
              key={index}
              href={resource.url}
              className={classes.link}
              target="_blank"
            >
              {label}
            </LinkMaterialUi>
          );
        })
      ) : typeof props.value === 'number' ? (
        <NumberFormat value={props.value} displayType={'text'} thousandSeparator={true} />
      ) : typeof props.value === 'boolean' ? (
        <Checkbox checked={props.value} disabled={true} color="primary" />
      ) : (
        <Box>{props.value}</Box>
      )}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: FontSizes.fontWeight.bold,
    cursor: 'pointer',
    marginLeft: -1 * (theme.spacing(6) + 1),
    marginRight: -1 * (theme.spacing(6) + 1),
    paddingLeft: theme.spacing(6),
  },
}));

export default LinkOrNumberOrTextOrBooleanCellRenderer;
